<template src="./Navigation.component.html"></template>
<style type="text/css" src="./Navigation.component.css"></style>

<script>
import { ToggleBus } from './../../main'
export default {
  name: 'Navigation',
  data () {
    return {}
  },
  methods: {
    toggleMenu(){
      ToggleBus.$emit("toggle")
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Navigation/Navigation.component.vue